<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2 p-1 ">
      <h2 class="mb-0 main-title">  Manage Vendors</h2>
      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-md btn-primary fs-11 fw-normal hover-white" @click="openCreateModal('createModal')">
          <i class="fa fa-plus fs-11"></i> Add New Vendor
        </button>
      </div>
    </div>
    <!-- Sirf Filters Bar -->
    <div class="filters-wrapper">
      <div class="filters-bar" id="filtersBar"></div>
      <button @click="resetAllFilters" class="btn btn-sm btn-outline-danger hover-white">
        <span class="material-symbols-outlined fs-6">undo</span> Reset
      </button>
    </div>

    <!-- Dropdown Template -->
    <div id="genericFilterDropdownTemplate" style="display: none;">
      <div class="generic-filter-dropdown">
        <div class="dropdown-header">
          <input type="text" class="filter-search-input" placeholder="Search...">
        </div>
        <div class="dropdown-body filter-options-container"></div>
        <div class="dropdown-footer">
          <button class="filter-clear-btn">Clear</button>
          <button class="filter-apply-btn">Apply</button>
        </div>
      </div>
    </div>
    <div class="card p-1 bg-white">


      <!-- Modal with CreateVendor inside slot -->
      <FormModal ref="createModal" title="Create New Vendor" id="create_vendor_form_modal">
        <CreateVendor @click="f" ref="createVendorForm" @created="onVendorCreated"
          @close="closeCreateModal('createModal')" />
      </FormModal>

      <!-- Modal with EditVendor inside slot -->
      <FormModal ref="editModal" title="Edit Vendor" id="edit_vendor_form_modal">
        <EditVendor v-if="editingVendorId" :key="editingVendorId" :vendor-id="editingVendorId"
          ref="editVendorForm" @updated="onVendorUpdated" @close="closeEditModal('editModal')" />
      </FormModal>

      <!-- <FormModal ref="secondModal" title="Second Modal" id="second_form_modal">
        <CreateVendor :roles="roles" ref="secondForm" @created="onVendorCreated" @close="closeCreateModal('secondModal')" />
      </FormModal> -->

      <!-- Loading State -->
      <LoadingBar v-if="loading" message="Loading Vendors..." />

     <div v-else class="table-wrapper">
  <ListTable>

    <colgroup>
      <!-- <col style="width: 6%">   -->
      <col style="width: 28%">  <!-- Vendor -->
      <col style="width: 14%">  <!-- Type -->
      <col style="width: 18%">  <!-- Description -->
      <col style="width: 14%">  <!-- Materials -->
      <col style="width: 13%">  <!-- Created On -->
      <col style="width: 13%">  <!-- Updated On -->
      <col style="width: 8%">   <!-- Action -->
    </colgroup>

    <thead>
      <tr>
        <!-- <th>SR#</th> -->

        <th @click="sortBy('first_name')" class="sortable">
          Vendor <i :class="getSortIcon('first_name')"></i>
        </th>

        <th>Type</th>
        <th>Description</th>
        <th>Materials/Nature</th>
        <th>Created On</th>
        <th>Updated On</th>
        <th class="text-center">Action</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="user in sortedData" :key="user.external_id">

        <!-- SR# -->
        <!-- <td>
            {{ index + 1 }}
        </td> -->

        <!-- Vendor -->
        <td class="align-middle">
          <div
            class="d-flex align-items-center gap-2"
            @click.prevent="profile(user)"
            style="cursor: pointer;">

            <div
              class="d-flex align-items-center justify-content-center bg-primary-subtle border border-primary-subtle rounded-3"
              style="width: 40px; height: 40px; min-width: 40px;">
              <span class="material-symbols-outlined text-primary fs-10">
                store
              </span>
            </div>

            <div>
              <a href="#" class="text-dark text-decoration-none">
                {{ user.first_name }} {{ user.last_name }}
              </a>
              <div class="text-muted small">
                {{ user.external_id }}
              </div>
            </div>
          </div>
        </td>

        <!-- Type -->
        <td class="align-middle" v-html="getVendorType(user.get_profile)"></td>

        <!-- Description -->
        <td>{{ user.get_profile?.description || '' }}</td>

        <!-- Materials / Contractor Nature -->
        <td>
          <template v-if="getVendorTypeString(user.get_profile) === 'vendor'">
            <ItemsDropdown
              :items="user.get_materials"
              label="Materials"
              serial-key="code"
              icon="flask"
              row-icon="flask"
            />
          </template>

          <template v-else-if="getVendorTypeString(user.get_profile) === 'contractor'">
            <NatureDropdown
              :natures="getContractorNature(user.get_profile)"
              label="Nature"
              icon="screwdriver-wrench"
              row-icon="screwdriver-wrench"
            />
          </template>

          <template v-else>
            <span class="text-muted">No materials / nature available</span>
          </template>
        </td>

        <!-- Created -->
        <td>{{ user.created_at }}</td>

        <!-- Updated -->
        <td>{{ user.updated_at }}</td>

        <!-- Action -->
        <td class="text-center">
          <TableActionDropdown>
            <li>
              <a class="dropdown-item" @click.prevent="profile(user)">
                <i class="fa fa-eye text-info"></i>
                <span>Profile</span>
              </a>
            </li>

            <li>
              <a class="dropdown-item" @click.prevent="edit(user)">
                <i class="fa fa-pencil text-primary"></i>
                <span>Edit</span>
              </a>
            </li>

          
              <hr class="dropdown-divider" />
   

            <li>
              <a class="dropdown-item item-danger" @click.prevent="deleteVendor(user)">
                <i class="fa fa-trash"></i>
                <span>Delete</span>
              </a>
            </li>
          </TableActionDropdown>
        </td>

      </tr>

      <tr v-if="sortedData.length === 0">
        <td colspan="8" class="text-center">
          No vendors found
        </td>
      </tr>

    </tbody>

  </ListTable>
</div>
      <!-- Pagination -->
      <Pagination :pagination="pagination" @page-change="changePage" />

    </div>
  </div>
    <ConfirmDeleteModal
  v-model="showDeleteModal"
  title="Delete Vendor"
  :item-name="deletingVendor?.first_name"
  :loading="deleting"
  @confirm="confirmDelete"
/>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import Pagination from '@/components/utils/PaginationBar.vue'
import LoadingBar from '@/components/utils/LoadingBar.vue'
import FormModal from '@/components/utils/FormModal.vue'
import CreateVendor from '@/views/Vendor/CreateVendor.vue'
import EditVendor from '@/views/Vendor/EditVendor.vue'
import ListTable from '@/components/utils/ListTable.vue'
import TableActionDropdown from '@/components/TableActionDropdown.vue'
import ItemsDropdown from '@/components/AttributesDropdown.vue'
import NatureDropdown from '@/components/NatureDropdown.vue'
import ConfirmDeleteModal from '@/components/utils/ConfirmDeleteModal.vue'
export default {
  name: 'VendorList',
  components: {
    Pagination,
    LoadingBar,
    FormModal,
    CreateVendor,
    EditVendor,
    ListTable,
    TableActionDropdown,
    ItemsDropdown,
    NatureDropdown,
      ConfirmDeleteModal
  },
  data() {
    return {
      vendors: [],
      roles: [],
      pagination: {
        total_rows: 0,
        per_page: 20,
        current_page: 1,
        total_pages: 1
      },
      loading: false,
      filterManager: null,
      sortColumn: null,
      sortOrder: 'asc',
      filteredData: [],
      currentFilters: {},
      editingVendorId: null,
        showDeleteModal: false,
      deletingVendor:    null,
      deleting:        false,
    }
  },
  computed: {

    // Sorted data
    sortedData() {
      let result = [...this.filteredData];

      if (this.sortColumn) {
        result.sort((a, b) => {
          let valA = a[this.sortColumn];
          let valB = b[this.sortColumn];

          if (valA === undefined || valA === null) valA = '';
          if (valB === undefined || valB === null) valB = '';

          if (this.sortColumn === 'id') {
            valA = parseInt(String(valA).replace('#', '')) || 0;
            valB = parseInt(String(valB).replace('#', '')) || 0;
          }

          if (typeof valA === 'string') valA = valA.toLowerCase();
          if (typeof valB === 'string') valB = valB.toLowerCase();

          if (valA < valB) return this.sortOrder === 'asc' ? -1 : 1;
          if (valA > valB) return this.sortOrder === 'asc' ? 1 : -1;
          return 0;
        });
      }

      return result;
    },
  },
  mounted() { //doc read
    // alert(localStorage.getItem('user_token'));
    this.fetchVendors()
    this.fetchRoles()
    this.$nextTick(() => {
      setTimeout(() => {
        this.initFilters();
      }, 100);
    });
  },
  methods: {
    getVendorType(profile) {
      if (!profile || !profile.vendor_type) return ''

      const vendorType = String(profile.vendor_type)
      return this.renderBadge(vendorType)
    },

    getVendorTypeString(profile) {
      if (!profile || !profile.vendor_type) return ''
      return String(profile.vendor_type).toLowerCase()
    },

    getContractorNature(profile) {
      if (!profile) return []

      const rawNature = profile.contractor_nature
      if (Array.isArray(rawNature)) {
        return rawNature.map(item => String(item))
      }

      if (typeof rawNature === 'string') {
        try {
          const parsed = JSON.parse(rawNature)
          return Array.isArray(parsed) ? parsed.map(item => String(item)) : [String(parsed)]
        } catch (e) {
          return rawNature ? [rawNature] : []
        }
      }

      return []
    },

    getVendorTypesForFilter(profile) {
      if (!profile || !profile.vendor_type) return []
      return [String(profile.vendor_type).toLowerCase()]
    },

renderBadge(text) {
  if (!text) return ''
  
  // First letter capital karo
  const formattedText = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
  
  // Badge HTML return karo with light colors
  return `<span class="badge bg-light text-dark me-1" style="background-color: ${this.getLightColor(text)} !important; padding: 5px 10px; font-weight: 500;">${formattedText}</span>`
},

getLightColor(str) {
  // Different colors for different vendor types
  const colors = {
    'vendor': '#cfe9ff',      // light blue
    'contractor': '#ffe8cf',  // light orange
    'retailer': '#e3f2fd',    // light blue
    'wholesaler': '#e8f5e8',  // light green
    'distributor': '#fff3e0', // light orange
    'manufacturer': '#fce4ec', // light pink
    'supplier': '#f3e5f5',    // light purple
    'default': '#f8f9fa'      // light gray
  }
  
  const lowerStr = str.toLowerCase()
  return colors[lowerStr] || colors.default
},
    openCreateModal(ref) {
      this.$refs[ref].showModal()

    },

    closeCreateModal(ref) {
      this.$refs[ref].closeModal()
    },

    openEditModal(ref) {
      this.$refs[ref].showModal()
    },

    closeEditModal(ref) {
      this.$refs[ref].closeModal()
      this.editingVendorId = null
    },

    edit(user) {
      // EditVendor fetches its own data by id, so just set the id and open the modal
      this.editingVendorId = user.id
      this.openEditModal('editModal')
    },

    async onVendorCreated() {
      this.pagination.current_page = 1
      await this.fetchVendors()
    },

    async onVendorUpdated() {
      await this.fetchVendors()
    },

   profile(vendor) {
  this.$router.push({ name: 'VendorProfile', params: { external_id: vendor.external_id } })
},

    async fetchVendors() {
      this.loading = true

      const result = await form_api_submit({
        url: 'vendor/list',
        method: 'GET',
        data: {
          page: this.pagination.current_page,
          ...this.currentFilters
        },
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        console.log(result);
        this.vendors = result.data.list
        this.filteredData = [...result.data.list]
        this.pagination = result.data.pagination
      }

      this.loading = false
    },
    async fetchRoles() {
      this.loading = true
      const result = await form_api_submit({
        url: 'roles/get-roles',
        method: 'GET',
        data: {

        },
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        this.roles = result.data.list || result.data || []
        console.log(this.roles);
      }

      this.loading = false
    },

    changePage(page) {
      if (page < 1 || page > this.pagination.total_pages) return
      this.pagination.current_page = page
      // alert(this.pagination.current_page);
      this.fetchVendors()
    },
    initFilters() {
      if (typeof $ === "undefined" || typeof GenericFilterManager === "undefined") return;

      this.filterManager = new GenericFilterManager({
        containerId: "filtersBar",
        filters: [
          {
            key: "id",
            label: "ID",
            type: "input",
            placeholder: "Filter by ID"
          },
          {
            key: "name",
            label: "Name",
            type: "input",
            placeholder: "Filter by Name"
          },
          {
            key: "vendor_type",
            label: "Vendor Type",
            type: "radio",
            options: [
              { value: "vendor", label: "Vendor" },
              { value: "contractor", label: "Contractor" }
            ]
          },
          {
            key: "description",
            label: "Description",
            type: "input",
            placeholder: "Filter by Description"
          }
        ],
        onFilterChange: (filters) => {
          this.applyFilters(filters);
        }
      });
    },

    applyFilters(activeFilters) {
      this.currentFilters = { ...activeFilters };
      this.pagination.current_page = 1;
      this.fetchVendors();
    },
    resetPagination() {
      this.pagination.current_page = 1;
      this.fetchVendors();
    },
    resetAllFilters() {
      if (this.filterManager) {
        this.filterManager.clearAllFilters();
      }
      this.currentFilters = {};
      this.sortColumn = null;
      this.sortOrder = 'asc';
      this.pagination.current_page = 1;
      this.fetchVendors();
    },
    // Sorting method
    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc';
      }
      this.resetPagination(); // Reset to first page when sorting changes
    },

    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return 'fas fa-sort text-muted';
      }
      return this.sortOrder === 'asc' ? 'fas fa-sort-up text-primary' : 'fas fa-sort-down text-primary';
    },
      deleteVendor(vendor) {
      this.deletingVendor = vendor
      this.showDeleteModal = true
    },

    async confirmDelete() {
      this.deleting = true
      try {
        const result = await form_api_submit({
          url: `vendor/delete/${this.deletingVendor.id}`,
          method: 'POST',
          show_success_toast: true,
          show_error_toast: true,
        })
        if (result.success) {
          this.showDeleteModal = false
          this.deletingVendor = null
          this.fetchVendors()
        }
      } finally {
        this.deleting = false
      }
    },
  }
}
</script>

<style scoped>
/* .card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.table th {
  background-color: #f8f9fa;
  font-weight: 600;
} */

.page-link {
  cursor: pointer;
}

.page-item.active .page-link {
  background-color: #667eea;
  border-color: #667eea;
}

img {
  object-fit: cover;
}
</style>